import axios from 'axios';
import { Command } from '../models/Command';
import {
  ICancelDownloadCommandsRequest,
  ICancelDownloadCommandsResponse,
  IQueuedCommand,
  IUpdateCommandRangeRequest,
} from '../models/QueuedCommand';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  getCommands(uid: number) {
    token = store.getters.token;
    return apiClient.get('/commands/' + uid, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteCommand(commandId: number) {
    token = store.getters.token;
    return apiClient.delete('/commands/' + commandId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  postCommand(command: Command) {
    token = store.getters.token;
    return apiClient.post('/commands/queue/', command, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  postCommands(commands: Command[]) {
    token = store.getters.token;
    return apiClient.post('/commands/queueList', commands, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  // EN-1516: queued commands for the devices in the caller's group.
  getQueuedCommands(params: { uid?: number; includeStopRows?: boolean } = {}) {
    token = store.getters.token;
    return apiClient.get<IQueuedCommand[]>('/commands/queued', {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
  },
  // EN-1516: change the range of a queued, unsent download (admin only).
  updateCommandRange(commandId: number, body: IUpdateCommandRangeRequest) {
    token = store.getters.token;
    return apiClient.put<IQueuedCommand>(
      '/commands/' + commandId + '/range',
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  /**
   * EN-1516 local adapter for Dave's EN-1515 cancel endpoint
   * (`POST /download-commands/cancel`, admin only, max 100 ids).
   * TODO(EN-1515): switch callers to DeviceService.cancelDownloadCommands
   * once it is on main, then delete this.
   */
  cancelDownloadCommandsAdapter(body: ICancelDownloadCommandsRequest) {
    token = store.getters.token;
    return apiClient.post<ICancelDownloadCommandsResponse>(
      '/download-commands/cancel',
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
};
